import gql from "graphql-tag";

export const deleteAnnouncementById = gql`
  mutation DeleteAnnouncement($id: ID) {
    deleteAnnouncement(where: { id: $id }) {
      id
    }
  }
`;
